import { ANALYTICS_HEAP_IDS, formatHeapId } from '@/common/constants';
import React from 'react';
import { SectionProps } from '../types';
import styles from './MarketingSectionBlockDesktop.module.scss';

export const MarketingSectionBlockDesktop: React.FC<SectionProps> = ({
  sectionName,
  marketingLinks,
}) => {
  return (
    <div className={styles['section-block']} key={sectionName}>
      <p className={styles['section-title']}>{sectionName}</p>
      <ul className={styles['section-links']}>
        {marketingLinks.map((link, index) => (
          <li key={`Desktop-${sectionName}-${link.text}-${link.link}-${index}`}>
            <a
              href={link.link}
              data-heap-id={formatHeapId([
                ANALYTICS_HEAP_IDS.DESKTOP,
                ANALYTICS_HEAP_IDS.FOOTER_MARKETING,
                sectionName,
                link.text,
              ])}
            >
              {link.text}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};
